/** 비디오 기능 슬라이스 — 블록 직렬화 + 리사이즈 컨트롤. (삽입은 업로드/파일패널/붙여넣기 경로) */
import { videoBlockToElement, videoElementToBlock } from "./video.js";
import { attachVideoControls } from "./controls.js";

export default {
  name: "video",
  blocks: { video: { toElement: videoBlockToElement, fromElement: videoElementToBlock } },
  controls: (editorEl, ctx) => attachVideoControls(editorEl, ctx),
  // 비디오 슬래시 — allowVideoUpload 시에만 노출(blocknote 동작 일치). 공용 파일 선택기 사용.
  slash: (ctx) => {
    if (!(ctx.opts && ctx.opts.allowVideoUpload)) return [];
    const SM = (ctx.locale && ctx.locale.slashMenu) || {};
    return [
      {
        type: "video",
        label: SM.video || "비디오",
        kw: "video 비디오 동영상 movie mp4",
        group: SM.groupMedia || "미디어",
        ico: "🎬",
        sub: "동영상 파일 업로드",
        action: () => ctx.openImagePicker && ctx.openImagePicker(),
      },
    ];
  },
};
